<div id="error-dialog">
    <div class="w-100-p h-100-p" fxLayout="column" fxLayoutAlign="space-between start">
        <div fxLayout="column" fxLayoutAlign="start start" class="error-listing w-100-p">
            <div class="h1 text-bold" [innerHTML]="data.header"></div>
            <div class="mt-1-em mb-1-em" fusePerfectScrollbar>
                <ul>
                    <li *ngFor="let message of data.messages" [innerHTML]="message"></li>
                </ul>
            </div>
        </div>
        <div fxLayout="row" fxLayoutGap="2em" fxLayoutAlign="center center" class="w-100-p">
            <ng-container *ngIf="guardRedirectUrlsAvailable()">
                <button
                    mat-flat-button
                    class="accent"
                    tabindex="-1"
                    *ngFor="let guardUrl of guardRedirectUrls"
                    (click)="openGuardRedirectUrl(guardUrl.url)"
                >
                    {{guardUrl.label}}
                </button>
            </ng-container>
            <button mat-flat-button class="accent" tabindex="-1" (click)="dialogClose()">Rozumím</button>
        </div>
    </div>
</div>
